<template>
  <div class="thumbnail">
    <img :src="page.thumbnail_url" alt="HallThumbnail" @click.self="play" />
  </div>
</template>

<script>
export default {
  name: "Thumbnail",
  props: {
    page: {
      type: Object,
      required: true
    }
  },
  methods: {
    play() {
      this.$emit("play-video")
    }
  }
}
</script>
